/**
 * Version Footer Component
 * 
 * Displays version information and session ID at the bottom of the page
 */

import React, { useState, useEffect } from 'react';
import { VERSION, BUILD_TIMESTAMP, BUILD_ID } from '../version';
import config from '../config';
import './VersionFooter.css';

function VersionFooter() {
  const [sessionId, setSessionId] = useState(localStorage.getItem('sessionId') || 'Not set');
  const [backendVersion, setBackendVersion] = useState({
    version: 'Loading...',
    buildId: '',
    buildTimestamp: '',
    loading: true,
    error: null
  });

  // Fetch backend version
  useEffect(() => {
    const fetchBackendVersion = async () => {
      try {
        const response = await fetch(config.endpoints.version);
        if (!response.ok) {
          throw new Error(`Failed to fetch backend version: ${response.status}`);
        }
        const data = await response.json();
        setBackendVersion({
          version: data.version,
          buildId: data.buildId,
          buildTimestamp: data.buildTimestamp,
          loading: false,
          error: null
        });
      } catch (error) {
        console.error('Error fetching backend version:', error);
        setBackendVersion({
          version: 'Error',
          buildId: '',
          buildTimestamp: '',
          loading: false,
          error: error.message
        });
      }
    };

    fetchBackendVersion();
    const interval = setInterval(fetchBackendVersion, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // Update session ID if it changes
  useEffect(() => {
    const checkSessionId = () => {
      const currentSessionId = localStorage.getItem('sessionId');
      if (currentSessionId !== sessionId) {
        setSessionId(currentSessionId || 'Not set');
      }
    };

    checkSessionId();
    const interval = setInterval(checkSessionId, 1000);
    return () => clearInterval(interval);
  }, [sessionId]);

  return (
    <div className="version-footer">
      <div className="version-info">
        <div className="frontend-version">
          <span className="version-label">Frontend:</span> {VERSION}
          <span className="build-id-label">Build:</span> {BUILD_ID}
          <span className="timestamp-label">Built:</span> {new Date(BUILD_TIMESTAMP).toLocaleString()}
        </div>
        <div className="backend-version">
          <span className="version-label">Backend:</span> {backendVersion.version}
          {backendVersion.buildId && (
            <>
              <span className="build-id-label">Build:</span> {backendVersion.buildId}
            </>
          )}
          {backendVersion.buildTimestamp && (
            <>
              <span className="timestamp-label">Built:</span> {new Date(backendVersion.buildTimestamp).toLocaleString()}
            </>
          )}
        </div>
      </div>
      <div className="session-info">
        <span className="session-label">Session ID:</span> {sessionId}
      </div>
    </div>
  );
}

export default VersionFooter;
